var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgAppFolderFilled = function SvgAppFolderFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 21 20",
    fill: "currentColor"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 2.5c.183 0 .361.06.507.172l.083.072L10.845 5h5.488a2.5 2.5 0 012.496 2.353l.004.147v6.667a2.5 2.5 0 01-2.353 2.496l-.147.004H4.667a2.5 2.5 0 01-2.496-2.354l-.004-.146V5A2.5 2.5 0 014.52 2.504l.147-.004H8z",
    fill: "#6E7D8C"
  })));
};
export default SvgAppFolderFilled;